<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M33.7501 35H6.25001C5.55938 35 5 35.5594 5 36.25V38.75C5 39.4406 5.55938 40 6.25001 40H33.7501C34.4408 40 35.0001 39.4406 35.0001 38.75V36.25C35.0001 35.5594 34.4408 35 33.7501 35ZM27.5892 7.87016C27.532 7.29599 27.2777 6.75934 26.8696 6.3514L20.8837 0.366213C20.3954 -0.122071 19.604 -0.122071 19.1157 0.366213L13.1313 6.3514C12.7232 6.75934 12.469 7.29599 12.4118 7.87016L10 32.5H30.0001L27.5892 7.87016ZM23.7501 23.9999C23.7501 24.4999 23.2501 24.9999 22.7501 24.9999H17.2501C16.7501 24.9999 16.2501 24.4999 16.2501 23.9999V20.9999C16.2501 20.4999 16.7501 19.9999 17.2501 19.9999H22.7501C23.2501 19.9999 23.7501 20.4999 23.7501 20.9999V23.9999Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationMonument"
};
</script>
